export interface WidgetProps {
  id: string; // Unique ID of the widget
  component?: React.ReactNode; // React component associated with the widget
  name?: string; // Title or name tha will be displayed by the widget
  data?: object | undefined | any; // The data object it requires to render the widget.
  sseUrl?: object | undefined | any; // Server Sent Events URL - In case the widget is supporting SSE
  view?: object | undefined | any; // Intermal visual properties of the widget (not editable by the end user)
  options?: object | undefined | any; // The visual properties of the widget the end user can modify at runtime
  security?: object | undefined | any; // Any security tokens that need to be passed to the widget
}

export interface TokenProps {
  mapboxApiToken?: string;
}

export interface DataURLProps {
  intermixApiUrl?: string;
  intermixSseApiUrl?: string;
  novaSvelteMFEUrl?: string;
  novaVueMFEUrl?: string;
}

export interface ConfiguredWidgetsProps {
  tokens: TokenProps;
  dataURLs: DataURLProps;
}

/**
 * Adapter Types
 */
export enum AdapterEnum {
  ZOID = 'ZOID',
  NOVA = 'NOVA',
}

/**
 * Zoid Adapter Config for iFrame Dimensions in px
 */
export interface Dimensions {
  width: string;
  height: string;
}

/**
 * Zoid Cross Domain Adapter Configuration
 */
export interface ZoidAdapterConfigProps extends AdapterConfig {
  tag: string;
  url: string;
  dimensions?: Dimensions;
  props: any;
}

/**
 * Zoid Cross Domain Adapter Configuration
 */
export interface ZoidAdapterConfig extends AdapterConfig {
  config: ZoidAdapterConfigProps;
}

/**
 * Airbnb Hyper Nova Entry point URLS
 */
export interface EntryPoint {
  name: string; // Name of the Nova App to render
  url: string; // Hypernova Client URL
}

/**
 * Nova Server Adapter Configuration
 */
export interface NovaAdapterConfigEntryPoints extends AdapterConfig {
  entryPoints: EntryPoint[];
}

/**
 * Nova Server Adapter Configuration
 */
export interface NovaAdapterConfig extends AdapterConfig {
  config: NovaAdapterConfigEntryPoints;
}

/**
 * Core Adapter Configuration
 */
export interface AdapterConfig {
  type: string; // Type of Adapter - zoid, nova
  id: string; // unique id
  config: any; // config object
}

/**
 * Card Meta data for Rendering
 */
export interface CardMetadata {
  widgetId: string;
  orderId: number;
  cardId: string;
  data?: any;
  options?: any;
  name?: string;
}

/**
 * Card Layout Spec
 */
export interface CardLayout {
  w: number;
  h: number;
  x: number;
  y: number;
  cardId?: string;
}

/**
 * Layout specification per Card
 */
export interface Layout {
  sm?: CardLayout;
  md?: CardLayout;
  lg?: CardLayout;
  xs?: CardLayout;
  xxs?: CardLayout;
}

/**
 * Card Layouts on the Grid/Canvas
 */
export interface GridCardLayouts {
  sm: CardLayout[];
  md: CardLayout[];
  lg: CardLayout[];
  xs: CardLayout[];
  xxs: CardLayout[];
}

/**
 * Card Meta Information on the Grid/Canvas
 */
export interface GridCards {
  cards: CardMetadata[];
}

/**
 * Dashboard Layout
 */
export interface DashboardCardWithLayout {
  metadata: CardMetadata;
  layout: Layout;
}

/**
 * Dashboard Layout
 */
export interface DashboardCard {
  card: DashboardCardWithLayout;
}

/**
 * Complete Dashboard Card Metadata
 */
export interface DashboardLayouts {
  name: string;
  config: DashboardCard[] | null;
}

export interface PreconfiguredDashboardProps {
  cards: DashboardCard[];
  layouts: DashboardLayouts;
}
